'use client'

import { useEffect } from 'react'
import { registerServiceWorker } from '@/lib/pwa/register-sw'

export function PWARegister() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      registerServiceWorker()
    }
  }, [])

  return null
}
